var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.compiledHtml !== '')?_c('div',{attrs:{"id":"privacy"}},[_c('div',{staticClass:"paragraph"},[_c('div',{staticClass:"head"},[_vm._v(_vm._s(_vm.$t('Privacy.title')))]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.compiledHtml)}})])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66bbe1e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Privacy.vue
// module id = null
// module chunks = 